jQuery( document ).ready(function($) {

    if($('.productfreemium_product').length > 0) {
        $('.add_to_cart_button_freemium').on('click', function(e) {
            var id = $(this).attr('data-id');
            console.log(id);
            e.preventDefault();
            $(this).prop('disabled', true);
            $(this).html('Veuillez patienter...');
            addToCart(id);
            return false;
          })
      
          function addToCart(p_id) {
              $.get('/?add-to-cart=' + p_id, function() {
                  window.location.href = '/panier/'
              });
          }
    }
});